































































































































































































































































































































import { mixins } from 'vue-class-component';
import { Component, Watch, Prop } from 'vue-property-decorator';
import { State } from 'vuex-class';
import store, { RootStoreState } from '@/store';
import { SwIcon } from '@libs/unified-ui-framework/src/shared/sw-icon';
import navItems from '@/core/nav-service/nav-data';
import SwRmApiMixin from '../../sw-rm-api-mixin/sw-rm-api-mixin.vue';
import { NavNode } from '@/core/nav-service/types';
import { CreateElement, VNode } from 'vue';
import { tooltip, TooltipDirValues } from '@libs/unified-ui-framework/src/shared/tooltip-dir';
import SwDiscreetProgress from './sw-discreet-progress-vertical.vue';
import SwStickProgressVertical from './sw-stick-progress-vertical.vue';
import { SwIconButton } from '@libs/unified-ui-framework/src/shared/sw-icon-button';
import { popover, PopoverDirValues } from '@libs/unified-ui-framework/src/shared/popover-dir';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import SwDefconTab from './sw-defcon-tab.vue';
import SwSecurityBreakdown from './sw-security-breakdown.vue';
import SwWhatIfSimulator from './sw-what-if-simulator.vue';
import { SwTabGroup, SwTabPage, TabProps, TabRenderData } from '@libs/unified-ui-framework/src/shared/sw-tab-layout';
import { CSSStyleOptions } from '@libs/unified-ui-framework/src/shared/common-types';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import SwInfoTab from './sw-info-tab.vue';
import { Threat } from '@/modules/sw-ftr-bill-meter/data';
import { CoreStoreState } from '../../core.store';
import { D3DataSpec } from './sw-risk-meter/types';
import SwRiskMeter from './sw-risk-meter/sw-risk-meter.vue';

@Component({
  components: {
    SwIcon,
    SwScrollView,
    SwDiscreetProgress,
    SwStickProgressVertical,
    SwIconButton,
    SwForm, SwFormRow,
    SwSecurityBreakdown,
    SwWhatIfSimulator,
    SwDefconTab,
    SwTabGroup,
    SwTabPage,
    SwInfoTab,
    SwRiskMeter,
  },
  directives: {
    tooltip,
    popover,
  },
})
export default class SwFtrRiskMeterPopover extends mixins(SwRmApiMixin) {
  @Prop()
  percent: string;
  @State((state: RootStoreState) => (state.CoreStoreModule.threatPercent))
  threatPercent: number;
  @State((state: RootStoreState) => (state.CoreStoreModule.whatIfThreatPercent))
  whatIfThreatPercent: number;
  hardReset() {
    store.commit('setBillmeterloading', { billmeterloading: true });
    this.processApi(true, (this.resetTenantId));
  }

  resetTenantId() {
    if (!this.bmResetAllowed) {
      return;
    }
    const internalSelectedTenantId = this.internalSelectedTenantId;
    this.internalSelectedTenantId = '';
    this.$nextTick(() => { this.internalSelectedTenantId = internalSelectedTenantId; });
  }

  get getDefcon() {
    return this.defcon;
  }

  get getDefconWhatIf() {
    console.log(`Defcon: ${this.defcon}`);
    return this.defconWhatIf;
  }

  navItems: NavNode[] = navItems;
  isClickPopoverVisible: boolean = false;
  displayInfoModal: boolean = false;
  cssPrefix: String = 'sw-risk-meter-popover';
  selectedVerticalTabId2: string = 'tab2';
  colorArray = [
    { color: '#FD0006', value: 1 },
    { color: '#FD9721', value: 2 },
    { color: '#FDCB2E', value: 3 },
    { color: '#EDE385', value: 4 },
    { color: '#97CC2D', value: 5 }];
  verticalTabsPropsRight: TabProps[] = [
    { tabId: 'tab1', label: 'Info', icon: 'info' },
    { tabId: 'tab2', label: 'DEFCON', icon: 'dashboard' },
    { tabId: 'tab3', label: 'What If', icon: 'topo' },
  ];
  graphData: any = {};
  graphData1: any = {};

  schema = {
    props : {
      propName : 'propValue',
    },
    data : {
      totalReading: '',
      needleReading: '',
      meterLabel: '',
    },
  };
  get basicData(): D3DataSpec {
    return {
      json : {
        props : {
          theme: 'dark',
          compWidth: 50,
          compHeight: 50,
          svgWidth: 960,
          svgHeight: 960,
          viewBoxWidth: 800,
          viewBoxHeight: 700,
          meterLabelFont: '6.1rem',
          compX: 400,
          compY: 400,
          colorStart: '#c72928',
          colorEnd: '#abee4b',
          needleColor: '#ff7918',
        },
        data : {
          totalReading: 2000,
          needleReading: this.getThreatsPercent * 20,
          meterLabel: 'Protection Strength',
        },
      },
    };
  }

  get getThreatsPercent() {
    return Number(this.threatPercent);
  }

  get getWhatIfThreatsPercent() {
    return Number(this.whatIfThreatPercent);
  }

  afterDestroy() {
    if (this.threatPercent > 0) {
      store.commit('setThreatPercent', { threatPercent: 0 });
    }
    if (this.whatIfThreatPercent > 0) {
      store.commit('setWhatIfThreatPercent', { whatIfThreatPercent: 0 });
    }
  }

  get basicData1(): D3DataSpec {
    return {
      json : {
        props : {
          theme: 'dark',
          compWidth: 50,
          compHeight: 50,
          svgWidth: 960,
          svgHeight: 960,
          viewBoxWidth: 800,
          viewBoxHeight: 700,
          meterLabelFont: '6.7rem',
          compX: 400,
          compY: 400,
          colorStart: '#c72928',
          colorEnd: '#abee4b',
          needleColor: '#ff7918',
        },
        data : {
          totalReading: 2000,
          needleReading: this.getWhatIfThreatsPercent * 20,
          meterLabel: 'Protection Strength',
        },
      },
    };
  }

  // @Watch('threatPercent')
  get getGraphData() {
    return this.graphData || {};
  }

  get getGraphData1() {
    return this.graphData1 || {};
  }
  // @State((state: RootStoreState) => (state.CoreStoreModule.layerThreeInnerLayersActivated))
  // layerThreeInnerLayersActivated:any;
  // @State((state: RootStoreState) => (state.CoreStoreModule.layerTwoInnerLayersActivated))
  // layerTwoInnerLayersActivated:any;
  // @State((state: RootStoreState) => (state.CoreStoreModule.layerOneInnerLayersActivated))
  // layerOneInnerLayersActivated:any;
  // layerThreeInnerLayersActivated1: boolean[] = this.layerThreeInnerLayersActivated;
  // layerTwoInnerLayersActivated1: boolean[] = this.layerTwoInnerLayersActivated;
  // layerOneInnerLayersActivated1: boolean[] = this.layerOneInnerLayersActivated;

  @State((state: RootStoreState) => (state.CoreStoreModule.weights))
  weights:any;
  onSelectTab(tabId: string) {
    this.selectedVerticalTabId2 = tabId;
    if (this.selectedVerticalTabId2 === 'tab1') {
      this.displayInfoModal = true;
      store.commit('setNavMode', { inEditMode: false });
    }
    if (this.selectedVerticalTabId2 === 'tab3') {
      this.callGraphData1();
      store.commit('setNavMode', { inEditMode: false });
    } else {
      this.callGraphData();
    }
    // if (this.selectedVerticalTabId2 === 'tab2') {
    //   this.updateDefcon(this.threats);
    // }
    // if (this.selectedVerticalTabId2 === 'tab3') {
    //   this.updateDefcon(this.threatsWhatIf);
    // }
  }
  defconColor(shieldLevel:boolean): String {
    const x = this.colorArray.find((color:any) => color.value === this.defcon);
    return x && (this.bmResetAllowed || shieldLevel) ? x.color : '#888888';
  }

  customizedTabRender2(h: CreateElement, data: TabRenderData): VNode {// tslint:disable-line
    return (
      <span style={{ minWidth: '85px' }} >
      <SwDefconTab
        {...{
          props: {
            mode: 'page',
            text: data.props.label,
            selected: data.active,
          },
        }}
      ></SwDefconTab>
      </span>
    ) as VNode;
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.bmResetAllowed))
  bmResetAllowed: string;
  @State((state: RootStoreState) => (state.CoreStoreModule.inEditMode))
  inEditMode: CoreStoreState['inEditMode'];
  @State((state: RootStoreState) => (state.CoreStoreModule.bmStartTime))
  bmStartTime: number;

  @State((state: RootStoreState) => (state.CoreStoreModule.defcon))
  defcon: number;
  @State((state: RootStoreState) => (state.CoreStoreModule.defconPrecise))
  defconPrecise: number;
  @State((state: RootStoreState) => (state.CoreStoreModule.defconWhatIf))
  defconWhatIf: number;
  @State((state: RootStoreState) => (state.CoreStoreModule.defconPreciseWhatIf))
  defconPreciseWhatIf: number;

  @State((state: RootStoreState) => (state.CoreStoreModule.tenants))
  tenants: any;

  @State((state: RootStoreState) => (state.CoreStoreModule.selectedTenantId))
  selectedTenantId: string;
  internalSelectedTenantId: string = '';

  @State((state: RootStoreState) => (state.CoreStoreModule.threats))
  threats: any | undefined;

  @State((state: RootStoreState) => (state.CoreStoreModule.threatsWhatIf))
  threatsWhatIf: any | undefined;

  @Watch('selectedTenantId')
  updateInternalSelectedTenantId() {
    this.internalSelectedTenantId = this.selectedTenantId;
  }
  @Watch('internalSelectedTenantId')
  updateSelectedTenantId() {
    store.commit('setSelectedTenantId', { selectedTenantId: this.internalSelectedTenantId });
  }

  @State((state: RootStoreState) => (state.CoreStoreModule.billmeterloading))
  billmeterloading: number;
  defconPrecise1: number = this.selectedVerticalTabId2 === 'tab2' ? this.defconPrecise : this.defconPreciseWhatIf;
  defcon1: number = this.selectedVerticalTabId2 === 'tab2' ? this.defcon : this.defconWhatIf;

  created() {
    console.log(this.threats);
    this.callGraphData();
    this.callGraphData1();
    // if (this.selectedVerticalTabId2 === 'tab2') {
    //   this.defconPrecise1 = this.defconPrecise;
    //   this.defcon1 = this.defcon;
    // }
    // if (this.selectedVerticalTabId2 === 'tab3') {
    //   this.defconPrecise1 = this.defconPreciseWhatIf;
    //   this.defcon1 = this.defconWhatIf;
    // }
  }

  // start() {
  //   if (this.selectedVerticalTabId2 === 'tab2') {
  //     this.defconPrecise1 = this.defconPrecise;
  //     this.defcon1 = this.defcon;
  //   }
  //   if (this.selectedVerticalTabId2 === 'tab3') {
  //     this.defconPrecise1 = this.defconPreciseWhatIf;
  //     this.defcon1 = this.defconWhatIf;
  //   }
  // }

  // get itemPercent(): Number {
  //   return localStorage.getItem('threatsPercent') ? Number(localStorage.getItem('threatsPercent')) : 0;
  // }

  // @Watch(this.itemPercent)
  mounted() {
    this.callGraphData();
    this.callGraphData1();
  }

  updated() {
    console.log(this.threats);
    this.callGraphData();
    this.callGraphData1();
    // if (this.selectedVerticalTabId2 === 'tab2') {
    //   this.defconPrecise1 = this.defconPrecise;
    //   this.defcon1 = this.defcon;
    // }
    // if (this.selectedVerticalTabId2 === 'tab3') {
    //   this.defconPrecise1 = this.defconPreciseWhatIf;
    //   this.defcon1 = this.defconWhatIf;
    // }
  }

  updateDefcon(threats: Threat[]) {
    // if (this.loading) {
    //   return;
    // }
    let defconCounted = 0;
    let defconTotal = 0;
    threats.forEach((threat: Threat) => {
      if (threat.show) {
        defconTotal += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        if (!threat.isPenetrating) {
          defconCounted += this.weights.rw[threat.globalIndex] * this.weights.lw[threat.globalIndex];
        }
      }
    });
    this.defconPrecise1 = (4 * defconCounted / defconTotal) + 1;
    if (this.defconPrecise1 > 4 && this.defconPrecise1 < 5) {
      this.defcon1 = 4;
    } else if (this.defconPrecise1 < 2 && this.defconPrecise1 > 1) {
      this.defcon1 = 2;
    } else {
      this.defcon1 = Math.round(this.defconPrecise1);
    }
  }
  get isBillMeter() {
    return this.currentPath === 'bill-meter';
  }

  get shieldLevel() {
    const shieldLevel = (this.defconPrecise - 1) / 4 * 12;
    console.log(`Shield: ${shieldLevel}`);
    return shieldLevel > 0 && shieldLevel < 1 ? 1 : shieldLevel;
  }

  get shieldLevel1() {
    const shieldLevel = (this.defconPreciseWhatIf - 1) / 4 * 12;
    return shieldLevel > 0 && shieldLevel < 1 ? 1 : shieldLevel;
  }

  get currentPath() {
    return this.$route.path.split('/')
    .slice(-1)[0];
  }

  get currentNavItem() {
    return navItems.find(x => x.id === this.currentPath);
  }

  get resetTooltip(): TooltipDirValues {
    return {
      content: 'Click to Reset Data',
      placement: 'right',
    };
  }

  get attachTooltip(): TooltipDirValues {
    return {
      content: 'Rolling 24-hour attack statistics updated every minute',
      placement: 'bottom',
    };
  }

  get clickPopoverValue(): PopoverDirValues {
    return {
      title: 'Click Popover',
      content: this.render1,
      trigger: 'controlled',
      withCloseIcon: false,
      visible: this.isClickPopoverVisible,
      onRequestClose: () => (this.isClickPopoverVisible = false),
    };
  }

  render1(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <span>Total</span>
        <span>Hi Hello</span>
      </div>
    ) as VNode;
  }

  onClickTrigger() {
    this.isClickPopoverVisible = !this.isClickPopoverVisible;
  }

  get showHideLegend(): CSSStyleOptions {
    return {
      visibility: this.selectedVerticalTabId2 === 'tab1' ? 'visible' : 'hidden',
    };
  }

  @Watch('threatPercent')
  callGraphData() {
    console.warn(this.threatPercent);
    this.assignGraphData(this.basicData.json);
  }

  assignGraphData(data:any) {
    // this.$nextTick(() => {
    // this.graphData = data;
    // });
    this.$nextTick(() => {
      this.graphData = data;
    });
  }

  @Watch('whatIfThreatPercent')
  callGraphData1() {
    this.assignGraphData1(this.basicData1.json);
  }

  assignGraphData1(data:any) {
    // this.$nextTick(() => {
    // this.graphData1 = data;
    // });
    this.$nextTick(() => {
      this.graphData1 = data;
    });
  }

  // Adding for Risk Meter calculations
  // @Watch('layerThreeInnerLayersActivated', { immediate: true, deep: true })
  // @Watch('layerTwoInnerLayersActivated', { immediate: true, deep: true })
  // @Watch('layerOneInnerLayersActivated', { immediate: true, deep: true })
  // checkIfToggleLayerIsNeeded() {

  //   if (this.layerOneInnerLayersActivated[1]) {
  //     this.layerOneInnerLayersActivated[0] = true;
  //   }

  //   if (this.layerTwoInnerLayersActivated[1]) {
  //     this.layerTwoInnerLayersActivated[0] = true;
  //   }

  //   let turnOffThirdLayer = true;
  //   let turnOnThirdLayer = false;

  //   for (let i = 0; i < this.layerThreeInnerLayersActivated.length; i += 1) {
  //     if (this.layerThreeInnerLayersActivated[i]) {
  //       turnOffThirdLayer = false;
  //       turnOnThirdLayer = true;
  //     }
  //   }

  //   if ((turnOffThirdLayer && this.layersActive[3]) || (turnOnThirdLayer && !this.layersActive[3])) {
  //     this.layerToggledRecently = 3;
  //     this.layersActive[3] = !this.layersActive[3];
  //   }

  //   let turnOffSecondLayer = true;
  //   let turnOnSecondLayer = false;

  //   for (let i = 0; i < this.layerTwoInnerLayersActivated.length; i += 1) {
  //     if (this.layerTwoInnerLayersActivated[i]) {
  //       turnOffSecondLayer = false;
  //       turnOnSecondLayer = true;
  //     }
  //   }

  //   if ((turnOffSecondLayer && this.layersActive[2]) || (turnOnSecondLayer && !this.layersActive[2])) {
  //     this.layerToggledRecently = 2;
  //     this.layersActive[2] = !this.layersActive[2];
  //   }

  //   let turnOffFirstLayer = true;
  //   let turnOnFirstLayer = false;

  //   for (let i = 0; i < this.layerOneInnerLayersActivated.length; i += 1) {
  //     if (this.layerOneInnerLayersActivated[i]) {
  //       turnOffFirstLayer = false;
  //       turnOnFirstLayer = true;
  //     }
  //   }

  //   if ((turnOffFirstLayer && this.layersActive[1]) || (turnOnFirstLayer && !this.layersActive[1])) {
  //     this.layerToggledRecently = 1;
  //     this.layersActive[1] = !this.layersActive[1];
  //   }
  // }

}
